import { DOCUMENT_REQUIREMENTS } from './businessDocumentsRequirements';

export const countryMap: Record<string, keyof typeof DOCUMENT_REQUIREMENTS> = {
  NG: 'NG',
  KE: 'KE',
  GH: 'GH'
};

export const businessTypeMap: Record<string, keyof (typeof DOCUMENT_REQUIREMENTS)['NG']> = {
  'Sole proprietorship': 'soleProprietorship',
  Partnerships: 'partnership',
  'Limited Liability Company': 'limitedLiability'
};

export const inputPdfAcceptValues = '.jpg,.jpeg,.png,.pdf';
